export class settingsSource {
  static source = null

  static setSource = (source) => {
      this.source = source
  }
}